import axios from 'axios'
import store from 'store'

var installStorage = {}
var config = window.localStorage.getItem('flow_installation_config')
if (config) {
  installStorage = JSON.parse(config)
}

function loadConfig () {
  return new Promise(function (resolve, reject) {
    if (installation.product === 'Flow-Access') {
      store.dispatch({
        type: 'SET_CONFIG',
        title: 'Flow Access',
        collapsegui: '768',
        ...installation
      });
      (async () => {
        await axios.request({
          url: (installation.api_base) + '2.3/settings/',
          method: 'get',
          headers: {
            'Cache-Control': 'no-cache'
          }
        }).then(settings => {
          settings.data = settings.data || {}
          console.log(settings.data)
          store.dispatch({
            type: 'SET_CONFIG',
            payload: Object.assign({}, installation, settings.data)
          })
          resolve()
        }).catch(err => {
          reject(err)
        })
      })()
    }
  })
}

let installation = require('../projects/' + process.env.REACT_APP_PROJECT + '/config/installation')

if (installation.product !== 'Flow-Access') {
  store.dispatch({
    type: 'SET_CONFIG',
    payload: {
      deepstream: '/deepstream',
      title: 'Flow',
      collapsegui: '768',
      ...installation,
      ...installStorage
    }
  })
  ;(async () => {
    let err, res
    [err, res] = await axios.request({
      url: '/config/installation.json',
      method: 'get',
      headers: {
        'Cache-Control': 'no-cache'
      }
    }).then(res => {
      return [null, res]
    }).catch(err => [err])
    if (err) return
    res.data = res.data || {}
    if (res.data.settings) {
      (async () => {
        let err, settings
        [err, settings] = await axios.request({
          url: (res.data.api_base || installation.api_base) + 'settings/',
          method: 'get',
          headers: {
            'Cache-Control': 'no-cache'
          }
        }).then(settings => {
          return [null, settings]
        }).catch(err => [err])
        if (err) {
          return
        }
        settings.data = settings.data || {}
        console.log(settings.data)
        store.dispatch({
          type: 'SET_CONFIG',
          payload: Object.assign({}, res.data, settings.data)
        })
        window.localStorage.setItem('flow_installation_config', JSON.stringify(Object.assign({}, installation, res.data, settings.data)))
      })()
    } else {
      store.dispatch({
        type: 'SET_CONFIG',
        payload: res.data
      })
      window.localStorage.setItem('flow_installation_config', JSON.stringify(Object.assign({}, installation, res.data)))
    }
  })()
}

export {
  loadConfig
}



// WEBPACK FOOTER //
// ./src/config/installation.js